import { css } from '@inter-ikea-kompis/web-component';
export default class IconPillGroupStyle {
    static getStyle(options) {
        const { spacing } = options.theme;
        return css `
			.container {
				flex-wrap: wrap;
				display: inline-flex;
			}
			::slotted(kompis-icon-pill) {
				margin: ${spacing.space25 / 16}rem;
			}
			kompis-icon-pill {
				margin: ${spacing.space25 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=IconPillGroupStyle.js.map